import { Button } from "@mui/material";
import React from "react";
import { NewAppointmentContext } from "../context/newAppointmentContext";
import NewAppointmentProps from "../interface/newAppointmentProps";

const CreateButton = (): React.JSX.Element => {
  const {
    newAppointment,
    doCreateAppointment,
  }: {
    newAppointment: NewAppointmentProps;
    setNewAppointment: (newAppointment: NewAppointmentProps) => void;
    doCreateAppointment: () => Promise<void>;
  } = React.useContext(NewAppointmentContext);

  const handleDisable = (): boolean => {
    return (
      newAppointment.creationIsLoading ||
      !newAppointment.type ||
      !newAppointment.date ||
      !newAppointment.time.from ||
      !newAppointment.time.to ||
      newAppointment.time.from > newAppointment.time.to ||
      !newAppointment.coach ||
      (newAppointment.directBooking &&
        !newAppointment.search.selectedParticipant)
    );
  };

  return (
    <Button
      disabled={handleDisable()}
      onClick={doCreateAppointment}
      variant="contained"
      color="secondary"
    >
      {newAppointment.creationIsLoading
        ? "Erstelle Termin..."
        : "Termin erstellen"}
    </Button>
  );
};

export default CreateButton;
